import React, { memo } from 'react'
import CommonDialog from '../../../common/components/dialog/CommonDialog'
import styles from './ArhiveProductDialog.module.scss'
import { SolarProduct } from '../../../model/solar-product/solar-product'
import { useDispatch } from 'react-redux'
import { hideLoader, showLoader } from '../../../stores/slices/loader-slice'
import { toast } from 'react-toastify'
import { useArchiveProductMutation } from '../../../service/solar-product-service'
import { getErrorMessage } from '../../../utils/error-handler'

type Props = {
    product: SolarProduct
    onCloseDialog: () => void
    onProductArchived: () => void
}

const ArhiveProductDialog: React.FC<Props> = memo((props: Props) => {
    const dispatch = useDispatch();
    const [archiveProduct, { isLoading }] = useArchiveProductMutation();

    const arhiveProduct = async () => {
        dispatch(showLoader());
        try {
            await archiveProduct(props.product.id!).unwrap();
            props.onProductArchived();
            toast.success(`Product ${props.product.isArchived ? 'unarchive' : 'archive'} successful`)
        } catch (error: any) {
            toast.error(getErrorMessage(error?.data) ?? 'An error occurred');
        } finally{
            dispatch(hideLoader())
            props.onCloseDialog();
        }
    }

    const cancel = () => {
        props.onCloseDialog();
    }

    return (
        <CommonDialog onCloseDialog={props.onCloseDialog}>
            <div className={styles.container}>
                <div className={styles.title}>
                    Are you sure you want to {
                        props.product.isArchived ? 'unarchive' : 'archive'
                    } this product?
                </div>
                <div className={styles.description}>
                    {
                        props.product.isArchived ? 'Unarchiving' : 'Archiving'
                    } a product will make it {
                        props.product.isArchived ? 'available' : 'unavailable'
                    } for purchase by customers.
                </div>

                <div className={styles.buttonContainer}>
                    <button className={`standardButton ${styles.button} ${styles.archiveButton}`} 
                      onClick={arhiveProduct}
                      disabled={isLoading}
                      >{
                        props.product.isArchived ? 'Unarchive' : 'Archive'
                    }</button>
                    <button className={`standardButton ${styles.button}`} onClick={cancel}>Cancel</button>
                </div>
            </div>
        </CommonDialog>
    )
})

export default ArhiveProductDialog